export const FINANCED_LEGAL = 'FINANCED_LEGAL'
export const LEGAL = 'LEGAL'
export const TPV = 'TPV'
export const GENERATOR = 'GENETATOR'
